module.exports = __webpack_public_path__ + "img/mandala-cocktail.6c9fe586.jpg";